export default __webpack_public_path__ + "static/consistent-header-breakpoints-40f3c0bd0f8e4a655a2c41b5aac4ee00.png";